export const utilitiesData = [
    {
        "id": "rates-depreciation-companies",
        "name": "Rates of Depreciation (Companies Act)",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Rates of Depreciation (Companies Act)"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Rates of Depreciation (Companies Act). Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/RATES_OF_DEPRECIATION/RATES_OF_DEPRECIATION.aspx"
    },
    {
        "id": "rates-depreciation-it",
        "name": "Rates of Depreciation (Income Tax Act)",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Rates of Depreciation (Income Tax Act)"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Rates of Depreciation (Income Tax Act). Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/RATES_OF_DEPRECIATION_2/RATES_OF_DEPRECIATION_2.aspx"
    },
    {
        "id": "rates-income-tax",
        "name": "Rates of Income Tax",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Rates of Income Tax"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Rates of Income Tax. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/Rates_of_Income_Tax/Rates_of_Income_Tax.aspx"
    },
    {
        "id": "penalty-late-filing-roc",
        "name": "Penalty for Late Filing in ROC",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Penalty for Late Filing in ROC"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Penalty for Late Filing in ROC. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/Penalty_for_Late_Filing_in_ROC/Penalty_for_Late_Filing_in_ROC.aspx"
    },
    {
        "id": "filing-fees-roc",
        "name": "Filing Fees (ROC)",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Filing Fees (ROC)"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Filing Fees (ROC). Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/Filingfees/Filingfees.aspx"
    },
    {
        "id": "tds-rates-nri",
        "name": "TDS Rates for NRI u/s 195",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "TDS Rates for NRI u/s 195"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to TDS Rates for NRI u/s 195. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/TDS_Rates_for_N_R_I_us_195/TDS_Rates_for_N_R_I_us_195.aspx"
    },
    {
        "id": "cost-inflation-index",
        "name": "Cost Inflation Index",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Cost Inflation Index"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Cost Inflation Index. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/COST_INFLATION_INDEX/COST_INFLATION_INDEX.aspx"
    },
    {
        "id": "ifsc-codes",
        "name": "IFSC Codes",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "IFSC Codes"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to IFSC Codes. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/IFSC_Codes/IFSC_Codes.aspx"
    },
    {
        "id": "rates-tds",
        "name": "Rates of TDS",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Rates of TDS"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Rates of TDS. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/Rates_of_TDS/Rates_of_TDS.aspx"
    },
    {
        "id": "micr-codes",
        "name": "MICR Codes",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "MICR Codes"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to MICR Codes. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/MICR_Codes/MICR_Codes.aspx"
    },
    {
        "id": "interest-nsc",
        "name": "Calculation of Interest on NSC",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Calculation of Interest on NSC"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Calculation of Interest on NSC. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/CALCULATION_OF_INTEREST_ON_NSC/CALCULATION_OF_INTEREST_ON_NSC.aspx"
    },
    {
        "id": "gold-silver-rates",
        "name": "Gold & Silver Rates",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Gold & Silver Rates"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Gold & Silver Rates. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/Gold_Silver_Rates/Gold_Silver_Rates.aspx"
    },
    {
        "id": "llp-fees",
        "name": "Limited Liability Partnership Fees",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Limited Liability Partnership Fees"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Limited Liability Partnership Fees. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/Limited_Liability_Partnership_Fees/Limited_Liability_Partnership_Fees.aspx"
    },
    {
        "id": "stamp-duty-rates",
        "name": "Rates of Stamp Duty",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Rates of Stamp Duty"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Rates of Stamp Duty. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/Rates_of_stamp_duty/Rates_of_stamp_duty.aspx"
    },
    {
        "id": "nic",
        "name": "National Industrial Classification (NIC)",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "National Industrial Classification (NIC)"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to National Industrial Classification (NIC). Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/NIC/NIC.aspx"
    },
    {
        "id": "deduction-80tta-80ttb",
        "name": "Comparison of Section 80TTA and 80TTB",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "Comparison of Section 80TTA and 80TTB"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to Comparison of Section 80TTA and 80TTB. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/Comparison_of_Deduction_Under_Section_80TTA_and_80TTB/Comparison_of_Deduction_Under_Section_80TTA_and_80TTB.aspx"
    },
    {
        "id": "hsn-rate-list",
        "name": "HSN Rate List",
        "blocks": [
            {
                "type": "heading",
                "level": "h3",
                "text": "HSN Rate List"
            },
            {
                "type": "paragraph",
                "text": "Rates and utilities relating to HSN Rate List. Access complete charts via the official link below."
            },
            {
                "type": "paragraph",
                "text": "Details are available in the official document."
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Utilities/HSN_RATE_LIST/HSN_RATE_LIST.aspx"
    }
];
